// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Title-module--cds--assistive-text--bcba7";
export var cdsHideFeedback = "Title-module--cds--hide-feedback--49b16";
export var cdsShowFeedback = "Title-module--cds--show-feedback--c6919";
export var cdsSkeleton = "Title-module--cds--skeleton--9d732";
export var cdsVisuallyHidden = "Title-module--cds--visually-hidden--26707";
export var title = "Title-module--title--c903f";